import React, { useState, useEffect } from 'react'
import {
    getCrifDataByUserIdtest
} from '../../CommunityActionCreator'
import Loader from '../../../../../../presentationals/Loader/Loader.component'

const LendersDetail = ({ rowData }) => {
    const [objectData, setObjectData] = useState('')
    const [loaderState, setLoader] = useState(false)

    useEffect(() => {
        getCrifApi()
    }, [])

    const getCrifApi = () => {
        setLoader(true)
        getCrifDataByUserIdtest(rowData.userId,Callback => {
            setObjectData(Callback)
            setLoader(false)
        })
    }



    return (
        <div className='container'>
            {loaderState ?
                <Loader />
                : ""}
            <h3><b>Crif Details</b></h3>
            <div className='row'>
                <div className='col-sm-8 col-xs-12' style={{ overFlow: 'auto' }}>
                    {objectData ? (
                        <div

                            dangerouslySetInnerHTML={{
                                __html: objectData
                            }}
                        ></div>
                    ) : (
                        ''
                    )}
                </div>


            </div>
        </div>
    )
}

export default LendersDetail;